import script from "./SnackbarContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./SnackbarContainer.vue?vue&type=script&setup=true&lang=ts"

import "./SnackbarContainer.vue?vue&type=style&index=0&id=2e8a6883&lang=scss"

const __exports__ = script;

export default __exports__